// Edit layer style rule: Custom TextField to edit a numerical setting

import { Stack, Typography } from '@mui/material';
import { theme_errorRed, theme_orange, theme_textColorBlended, theme_textColorMain } from '../../../Theme';
import { CustomTextField } from '../EditLayer';



//-------------------------------------------------------------------------------
// Component props
//-------------------------------------------------------------------------------
export interface EditLayerStyleRule_Setting_Number_Props
{
  name: string;
  name_font_size: string;
  min_value: number;
  max_value: number;
  value?: number;
  default_value?: number;
  is_default_rule: boolean;
  OnChangeHandler: any;
  margin_left?: number;
  width?: string;
}

//-------------------------------------------------------------------------------
// Edit layer style rule: Custom TextField to edit a numerical setting
//-------------------------------------------------------------------------------
export function EditLayerStyleRule_Setting_Number(props: EditLayerStyleRule_Setting_Number_Props) 
{








  


  // Main render

  return (

    <Stack sx={{ ml: props.margin_left }}>
      <Typography sx={{ fontSize: props.name_font_size, color: theme_textColorBlended+'B0' }}>
        {props.name} ({props.min_value}-{props.max_value})
      </Typography>
      <CustomTextField variant='standard' size='small' autoComplete='off' 
                       inputProps={{ type: 'number' }}
                       value={props.value} onChange={props.OnChangeHandler}
                       sx={{ p: 0, width: props.width }}/>
      {RenderDefaultValue(props.value, props.default_value, props.is_default_rule, undefined)}
    </Stack>

  )
}



//-------------------------------------------------------------------------------
// Renders the default value/status.
// This version is primarily for numerical values, but can also work with string/enums.
//-------------------------------------------------------------------------------
function RenderDefaultValue(value: number | string | undefined, value_default: number | string | undefined, 
                                   is_default_rule: boolean, special_value_to_inherit: number | string | undefined)
{
  // If this is happening inside the "Default Rule", we show nothing
  if(is_default_rule===true)
    return null;

  // If the value IS the special inherit value, we show nothing
  if(value !== undefined && value!==special_value_to_inherit)
    return null;

  // If the value is a string, we do a case-insensitive comparison
  if(value?.toString().toLocaleLowerCase() !== special_value_to_inherit?.toString().toLocaleLowerCase())
    return null;

  return (

    <Stack direction='row' sx={{ alignItems: 'center' }}>

      <Typography sx={{ fontSize: '0.7rem', color: theme_textColorMain+'70'}}>
        Default:
      </Typography>

      {value_default !== undefined && value_default !== special_value_to_inherit
        ?
          // We have a default value - show it
          <Typography sx={{ ml: 0.5, fontSize: '0.7rem', color: theme_orange+'A0', textTransform: 'capitalize' }}>
            {value_default}
          </Typography>
        : // No default value is set - show a warning
          <Typography sx={{ ml: 0.5, fontSize: '0.7rem', color: theme_errorRed}}>
            Not Set
          </Typography>
      }

    </Stack>
  )
}

